import { packagesSlug, accessoriesSlug } from "@utils/routes";
import { SanitySyncProductDocument } from "@models/product.model";
import { ProductModals } from "@models/product-globals.model";
import BundleSlider from "./bundle-slider";
import BundleProduct from "./bundle-product";
import AccessoryProduct from "./accessory-product";
import * as Styled from "./Product.styled";

import { ReactComponent as CaretBackSVG } from "@images/caret_back.svg";
import { useShopifyProduct } from "@providers/product-provider";
import { useEffect } from "react";
import parse from "html-react-parser";
import { Shopify } from "@models/shopify.model";

export interface ProductProps {
  productDocument: SanitySyncProductDocument;
  modals?: ProductModals;
}

export interface SharedProductProps {
  productDocument: SanitySyncProductDocument;
  storefrontProduct: Shopify.Product;
}

const Product = ({ productDocument, modals }: ProductProps) => {
  const { title, subtitle, descriptionHtml, tags, images } = productDocument;
  const isBundle = tags.includes("bundle");
  const backUrl = isBundle ? packagesSlug : accessoriesSlug;
  const { state: productState, dispatch, getShopifyProduct } = useShopifyProduct();
  const storefrontProduct = productState.products[productDocument.handle];

  useEffect(() => {
    getShopifyProduct(dispatch, productDocument.handle);
  }, [productDocument.handle]);

  const sharedProductProps = {
    productDocument,
    storefrontProduct,
  };

  return (
    <Styled.Container className="product" bundle={isBundle}>
      <div className="grid-container">
        <Styled.Back>
          <Styled.BackButton href={backUrl}>
            <CaretBackSVG />
            <span>Back</span>
          </Styled.BackButton>
        </Styled.Back>

        <Styled.MobileHeading>
          <h1 className="h3">{title}</h1>
          {subtitle?.value && <p>{subtitle.value}</p>}
          {isBundle && descriptionHtml && parse(descriptionHtml)}
        </Styled.MobileHeading>

        <div className="grid-x grid-padding-x">
          <div className="cell small-12 medium-12 large-6">
            <BundleSlider images={images} />
          </div>

          <div className="cell small-12 medium-12 large-6">
            {isBundle ? (
              <BundleProduct {...sharedProductProps} modals={modals} />
            ) : (
              <AccessoryProduct {...sharedProductProps} />
            )}
          </div>
        </div>
      </div>
    </Styled.Container>
  );
};

export default Product;
